import { render, staticRenderFns } from "./portevacuation.vue?vue&type=template&id=3f4aeee2&scoped=true"
import script from "./portevacuation.vue?vue&type=script&lang=js"
export * from "./portevacuation.vue?vue&type=script&lang=js"
import style0 from "./portevacuation.vue?vue&type=style&index=0&id=3f4aeee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4aeee2",
  null
  
)

export default component.exports